<template>
  <div class="card">
    <div class="card-header">
      <h3 class="cart-title">
        <a data-action="collapse">Other texts</a>
      </h3>
      <div class="heading-elements">
        <ul class="list-inline mb-0">
          <li>
            <a
              v-b-toggle="`collapseSection-5`"
              data-action="collapse"
            ><i data-feather="chevron-down" /></a>
          </li>
        </ul>
      </div>
    </div>
    <div class="card-content collapse show">
      <b-collapse
        :id="`collapseSection-5`"
        visible
      >
        <div class="card-body">
          <b-tabs>
            <b-tab
              v-for="lang in langs"
              :key="lang"
            >
              <template #title>
                {{ lang.toUpperCase() }}
              </template>
              <b-tabs>
                <b-tab
                  v-if="referees"
                  active
                >
                  <template #title>
                    Section for referees <span
                      v-if="selectedTexts['referees'] || (convo.texts && convo.texts.referees)"
                      class="text-success ms-1"
                    ><i data-feather="check" /></span>
                  </template>
                  <label
                    for=""
                    class="form-label"
                  >Text for referees</label>
                  <TextArea
                    name="texts['referees']"
                    :answer="{value: convo.texts && convo.texts[lang].referees ? convo.texts[lang].referees.text : ''}"
                    :edit="true"
                    @submitAnswer="submitAnswer($event, 'referees', lang)"
                  />
                </b-tab>
                <b-tab>
                  <template #title>
                    Opening text <span
                      v-if="selectedTexts['opening'] || (convo.texts && convo.texts.opening)"
                      class="text-success ms-1"
                    ><i data-feather="check" /></span>
                  </template>
                  <label
                    for=""
                    class="form-label"
                  >Text for opening</label>
                  <TextArea
                    name="texts['opening']"
                    :answer="{value: convo.texts && convo.texts[lang].opening ? convo.texts[lang].opening.text : ''}"
                    :edit="true"
                    @submitAnswer="submitAnswer($event, 'opening', lang)"
                  />
                </b-tab>
                <b-tab>
                  <template #title>
                    Ending text <span
                      v-if="selectedTexts['ending'] || (convo.texts && convo.texts.ending)"
                      class="text-success ms-1"
                    ><i data-feather="check" /></span>
                  </template>
                  <label
                    for=""
                    class="form-label"
                  >Text for ending</label>
                  <TextArea
                    name="texts['ending']"
                    :answer="{value: convo.texts && convo.texts[lang].ending ? convo.texts[lang].ending.text : ''}"
                    :edit="true"
                    @submitAnswer="submitAnswer($event, 'ending', lang)"
                  />
                </b-tab>
              </b-tabs>
            </b-tab>
          </b-tabs>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { BCollapse, BTab, BTabs } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import TextArea from '../../../../convos/partials/input-types/TextArea.vue'

export default {
  components: {
    TextArea,
    BCollapse,
    BTab,
    BTabs,
  },
  props: {
    referees: { type: Boolean, required: false, default: true },
  },
  data() {
    return {
      selectedTexts: {
        es: {},
        en: {},
        ca: {},
      },
      langs: ['es', 'en', 'ca'],
    }
  },
  computed: {
    ...mapGetters({
      convo: 'convo/convo',
    }),
  },
  mounted() {
    feather.replace({
      width: 14,
      height: 14,
    })
  },
  methods: {
    submitAnswer(data, type, lang) {
      this.selectedTexts[lang][type] = data
      this.$emit('saveAnswer', { id: 'texts', data: this.selectedTexts })
    },
  },
}
</script>
